import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'potscommonui/src/app/component-library';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { PanelistService } from './services/panelist.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  objLoaderStatus: boolean;
  subscription: Subscription;
  constructor(
    private loaderService: LoaderService,
    private authService: AuthService,
    private panelistService: PanelistService,
    private router: Router,
    private translate: TranslateService, 
    private primeNGConfig: PrimeNGConfig

  ) {
    this.objLoaderStatus = false;
    translate.use('it');
    this.translate.get('primeng').subscribe(res =>
    this.primeNGConfig.setTranslation(res)
    );
  }
  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.authService.autoAuthUser();
    this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
    this.authService.controlLoader.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
    this.panelistService.panelistLoader.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
  }
}
